module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-info-a88f0546d758804f69df84f3e12849c8.png";